import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Dropdown, DropdownItem} from '@homeaway/react-dropdown';
import triggerEdapEvent from '../../utils/edap';

class CurrencySelector extends Component {
    static propTypes = {
        currencyList: PropTypes.arrayOf(
            PropTypes.shape({
                code: PropTypes.string,
                symbol: PropTypes.string,
                name: PropTypes.string
            })
        ),
        title: PropTypes.string,
        disclaimer: PropTypes.string,
        code: PropTypes.string,
        onChange: PropTypes.func
    }

    static defaultProps = {
        title: 'Currency',
        disclaimer: 'Please note: You will still be charged in the owner\'s currency.',
        currency: {code: 'USD', symbol: 'US$', name: 'US Dollar'},
        currencyList: [],
        onChange: () => {}
    }

    /* istanbul ignore next */
    constructor(props) {
        super(props);
    }

    handleChange = (event, currency) => {
        event.preventDefault();
        const currencyCodeSelected = currency.code;
        this.props.onChange(currencyCodeSelected);
    }

    handleDropdownShow() {
        triggerEdapEvent({
            eventaction: 'display currency dropdown clicked'
        });
    }

    render() {
        const {title, currency, disclaimer, currencyList} = this.props;
        return (
            <div className="currency-selector PreferenceSelector form-group">
                <div className="PreferenceSelector__title">{title}</div>
                <Dropdown
                    srOnlyLabel
                    label={title}
                    buttonChildren={
                        <span className="PreferenceSelector__selected-option">
                            <div className="option-currency-code">{currency.code}</div>
                            <span className="option-currency-name">{`${currency.name} (${currency.symbol})`}</span>
                        </span>
                    }
                    id="currency-selector"
                    name="currency-selector"
                    onDropdownShow={this.handleDropdownShow}
                >
                    {currencyList.map((c) => {
                        return (
                            <DropdownItem
                                link="#"
                                text={
                                    <span className="PreferenceSelector__option">
                                        <div className="option-currency-code">{c.code}</div>
                                        <span className="option-currency-name">{c.name}</span>
                                    </span>
                                }
                                key={c.code}
                                onClick={(event) => this.handleChange(event, c)} // eslint-disable-line react/jsx-no-bind
                            />
                        );
                    })}
                </Dropdown>
                <p className="help-block PreferenceSelector__disclaimer">{disclaimer}</p>
            </div>
        );
    }
}

export default CurrencySelector;
